import { Button, DefaultComponentProps, Dialog, DialogActions, DialogContent, DialogTitle, FlexGrid, Typography } from '@albo-ui/core';
import { TextField, MenuItem, Select } from '@mui/material';
import { useBatchForm } from './hooks/useBatchForm';
import { batchType } from '../../../util/DataObject';

export const CreateBatch = ({ onConfirm, onClose, open, title }: any & DefaultComponentProps) => {
	const { form, onHandleChange, isValidForm } = useBatchForm(open)
	
	return (
		<Dialog onClose={onClose} open={open} >
			<DialogTitle>
				<Typography variant='h2'>{title}</Typography>
			</DialogTitle>
			<DialogContent>
				<FlexGrid container direction='column' alignItems='flex-start' spacing={2} style={{marginTop: 20}}>
					<FlexGrid container spacing={2} fullWidth>
						<Select value={form.type || '-1'} onChange={onHandleChange.bind(this, 'type', '')} color='secondary' MenuProps={{style: {zIndex: 35001}}} sx={{width: '49%'}} >
							<MenuItem value={'-1'} disabled>Tipo</MenuItem>
							{batchType.map((item) => {
								return <MenuItem key={item.value} value={item.value}>{item.label}</MenuItem>
							})}
						</Select>
						<TextField type='number' value={form.limit} onInput={onHandleChange.bind(this, 'limit', '')} label='Limite' color='secondary' sx={{width: '49%'}}/>
					</FlexGrid>
						<TextField value={form.batch_uuid} onInput={onHandleChange.bind(this, 'batch_uuid', '')} label='Batch UUID' color='secondary' fullWidth/>
					<FlexGrid container spacing={2} fullWidth>
					</FlexGrid>
					{form.type === 'email' &&
						<FlexGrid container spacing={2} fullWidth>
							<TextField value={form.body['template_id'] || ''} onInput={onHandleChange.bind(this, 'body', 'template_id')} label='Template ID' color='secondary' fullWidth/>
							<TextField value={form.body['summary'] || ''} onInput={onHandleChange.bind(this, 'body', 'summary')} label='Descripción' color='secondary' fullWidth/>
						</FlexGrid> 
					}
					{(form.type === 'push' || form.type === 'notification_center') &&
						<FlexGrid container spacing={2} fullWidth>
							<TextField value={form.body['title'] || ''} onInput={onHandleChange.bind(this, 'body', 'title')} label='Titulo' color='secondary' fullWidth/>
							<TextField value={form.body['content'] || ''} onInput={onHandleChange.bind(this, 'body', 'content')} label='Descripción' color='secondary' fullWidth/>
						</FlexGrid> 
					}
					{form.type === 'sms' &&
						<FlexGrid container spacing={2} fullWidth>
							<TextField value={form.body['content'] || ''} onInput={onHandleChange.bind(this, 'body', 'content')} label='Descripción' color='secondary' fullWidth/>
						</FlexGrid>
					}
				</FlexGrid>
			</DialogContent>

			<DialogActions>
				<FlexGrid container fullHeight fullWidth justify='space-between' alignItems='flex-end' style={{ marginTop: '20px' }}>
					<FlexGrid item>
						<Button onClick={onClose} buttonType='secondary' size='normal'>
							Cancelar
						</Button>
					</FlexGrid>
					<FlexGrid item>
						<Button onClick={() => onConfirm(form)} disabled={isValidForm} size='normal'>
							Aceptar
						</Button>
					</FlexGrid>
				</FlexGrid>
			</DialogActions>
		</Dialog>
	)
}